import _extends from "@babel/runtime/helpers/extends";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _objectSpread from "@babel/runtime/helpers/objectSpread";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import { CheckoutBillingAddress } from "@components/organisms";
import { useCart, useCheckout, useUserDetails } from "@sdk/react";
import { ShopContext } from "@temp/components/ShopProvider/context";
import { filterNotEmptyArrayItems } from "@utils/misc";
import React, { forwardRef, useContext, useEffect, useImperativeHandle, useRef, useState } from "react";
import { useIntl } from "react-intl";
import { errorCommonMsg } from "../../../../intl";

var CheckoutBillingAddressSubpageWithRef = function CheckoutBillingAddressSubpageWithRef(_ref, ref) {
  var _checkout$billingAddr, _user$addresses;

  var changeSubmitProgress = _ref.changeSubmitProgress,
      onSuccess = _ref.onSuccess,
      props = _objectWithoutProperties(_ref, ["changeSubmitProgress", "onSuccess"]);

  var intl = useIntl();

  var _useUserDetails = useUserDetails(),
      user = _useUserDetails.data;

  var _useCheckout = useCheckout(),
      checkout = _useCheckout.checkout,
      billingAsShipping = _useCheckout.billingAsShipping,
      setBillingAddress = _useCheckout.setBillingAddress,
      setBillingAsShippingAddress = _useCheckout.setBillingAsShippingAddress,
      selectedBillingAddressId = _useCheckout.selectedBillingAddressId;

  var _useCart = useCart(),
      items = _useCart.items;

  var _useContext = useContext(ShopContext),
      countries = _useContext.countries;

  var isShippingRequiredForProducts = items && items.some(function (_ref2) {
    var _variant$product;

    var variant = _ref2.variant;
    return (_variant$product = variant.product) === null || _variant$product === void 0 ? void 0 : _variant$product.productType.isShippingRequired;
  });

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      billingErrors = _useState2[0],
      setBillingErrors = _useState2[1];

  var _useState3 = useState(billingAsShipping),
      _useState4 = _slicedToArray(_useState3, 2),
      billingAsShippingState = _useState4[0],
      setBillingAsShippingState = _useState4[1];

  useEffect(function () {
    setBillingAsShippingState(true);
  }, [billingAsShipping]);
  var checkoutBillingAddress = (checkout === null || checkout === void 0 ? void 0 : checkout.billingAddress) ? _objectSpread({}, checkout === null || checkout === void 0 ? void 0 : checkout.billingAddress, {
    phone: (checkout === null || checkout === void 0 ? void 0 : (_checkout$billingAddr = checkout.billingAddress) === null || _checkout$billingAddr === void 0 ? void 0 : _checkout$billingAddr.phone) || undefined
  }) : undefined;
  var checkoutBillingFormId = "billing-form";
  var checkoutBillingFormRef = useRef(null);
  var checkoutNewAddressFormId = "new-address-form";
  useImperativeHandle(ref, function () {
    return {
      submitBillingAddress: function submitBillingAddress() {
        if (billingAsShippingState) {
          handleSetBillingAddress();
        } else if (user && selectedBillingAddressId) {
          checkoutBillingFormRef.current.dispatchEvent(new Event("submit", {
            cancelable: true
          }));
        } else {
          // TODO validate form
          checkoutBillingFormRef.current.dispatchEvent(new Event("submit", {
            cancelable: true
          }));
        }
      }
    };
  });

  var handleSetBillingAddress =
  /*#__PURE__*/
  function () {
    var _ref3 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee(address, email, userAddressId) {
      var billingEmail, errors, _ref4, dataError, _ref5, _dataError;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(!address && !billingAsShippingState)) {
                _context.next = 3;
                break;
              }

              setBillingErrors([{
                message: intl.formatMessage(errorCommonMsg.provide_billing_address)
              }]);
              return _context.abrupt("return");

            case 3:
              billingEmail = (user === null || user === void 0 ? void 0 : user.email) || email;

              if (!(!billingEmail && !billingAsShippingState && !isShippingRequiredForProducts)) {
                _context.next = 7;
                break;
              }

              setBillingErrors([{
                field: "email",
                message: intl.formatMessage(errorCommonMsg.provide_email_address)
              }]);
              return _context.abrupt("return");

            case 7:
              changeSubmitProgress(true);

              if (!(billingAsShippingState && isShippingRequiredForProducts)) {
                _context.next = 16;
                break;
              }

              _context.next = 11;
              return setBillingAsShippingAddress();

            case 11:
              _ref4 = _context.sent;
              dataError = _ref4.dataError;
              errors = dataError === null || dataError === void 0 ? void 0 : dataError.error;
              _context.next = 21;
              break;

            case 16:
              _context.next = 18;
              return setBillingAddress(_objectSpread({}, address, {
                id: userAddressId
              }), billingEmail);

            case 18:
              _ref5 = _context.sent;
              _dataError = _ref5.dataError;
              errors = _dataError === null || _dataError === void 0 ? void 0 : _dataError.error;

            case 21:
              changeSubmitProgress(false);

              if (errors) {
                setBillingErrors(errors);
              } else {
                setBillingErrors([]);
                onSuccess();
              }

            case 23:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleSetBillingAddress(_x, _x2, _x3) {
      return _ref3.apply(this, arguments);
    };
  }();

  return React.createElement(CheckoutBillingAddress, _extends({}, props, {
    billingErrors: billingErrors,
    billingFormId: checkoutBillingFormId,
    billingFormRef: checkoutBillingFormRef,
    userAddresses: user === null || user === void 0 ? void 0 : (_user$addresses = user.addresses) === null || _user$addresses === void 0 ? void 0 : _user$addresses.filter(filterNotEmptyArrayItems).map(function (_ref6) {
      var isDefaultBillingAddress = _ref6.isDefaultBillingAddress,
          isDefaultShippingAddress = _ref6.isDefaultShippingAddress,
          phone = _ref6.phone,
          address = _objectWithoutProperties(_ref6, ["isDefaultBillingAddress", "isDefaultShippingAddress", "phone"]);

      return _objectSpread({}, address, {
        isDefaultBillingAddress: !!isDefaultBillingAddress,
        isDefaultShippingAddress: !!isDefaultShippingAddress,
        phone: phone || undefined
      });
    }),
    selectedUserAddressId: selectedBillingAddressId,
    checkoutBillingAddress: checkoutBillingAddress,
    countries: countries,
    setBillingAddress: handleSetBillingAddress,
    billingAsShippingPossible: !!isShippingRequiredForProducts,
    billingAsShippingAddress: billingAsShippingState,
    setBillingAsShippingAddress: setBillingAsShippingState,
    userId: user === null || user === void 0 ? void 0 : user.id,
    newAddressFormId: checkoutNewAddressFormId
  }));
};

var CheckoutBillingAddressSubpage = forwardRef(CheckoutBillingAddressSubpageWithRef);
export { CheckoutBillingAddressSubpage };